import { Injectable } from "@angular/core";
import { CompletionBehaviorTemplate } from "../../../entities/completionBehaviorTemplate/completionBehaviorTemplate";
import { ToastService } from "../../toast/toast.service";
import { CompletionBehavior, HasCommands, Reloadable } from "../command.service";
import { RefetchCoordinator } from "../../refetch-coordinator/refetch-coordinator.service";

@Injectable({
    providedIn: 'root'
  })
export class ReloadCompletionBehavior implements CompletionBehavior {

    constructor(
        private toastService: ToastService,
        readonly refetchCoordinator: RefetchCoordinator
    ) { }

    executeCompletionBehavior(hasCommands: HasCommands, completionBehaviorTemplate: CompletionBehaviorTemplate, reloadable?: Reloadable) {

        // trigger a reload of affected lists
        // this might be not necessary for all updates, but for simplicity we do it here
        // its basically only for updating filters in lists. E.g. if an issue´s status is
        // changed. Most of the data will be updated via apollo cache updates anyway
        if(hasCommands && typeof hasCommands.getEntityType === 'function'){
            this.refetchCoordinator.emit({ entityType: hasCommands.getEntityType() });
        }

        const showToast = completionBehaviorTemplate?.settings?.showToast;
        const toastMessage = completionBehaviorTemplate?.settings?.toastMessage;
        if(reloadable){
            reloadable.reload();
        }

        if(showToast && toastMessage){
            this.toastService.addToastWithMessage(toastMessage);
        }

    }

}
